import { Controller } from "@hotwired/stimulus"
import "./component.scss"

export default class extends Controller {
  static targets = ["navigation"]

  connect() {
    // Reserve the fixed bar's actual height, including safe-area padding.
    this.resizeObserver = new ResizeObserver(() => this.reserveSpace())
    this.resizeObserver.observe(this.navigationTarget)
    this.reserveSpace()
  }

  disconnect() {
    this.resizeObserver.disconnect()
  }

  reserveSpace() {
    this.element.style.height = `${this.navigationTarget.getBoundingClientRect().height}px`
  }
}
